import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  cancelCustomersBatchJob,
  getCustomersBatchFailures,
  getCustomersBatchList,
  uploadCustomersBatchFile,
} from "controller/api";
import type { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

export const useUploadCustomerBatchFile = () => {
  const queryClient = useQueryClient();
  return useMutation((file: any) => uploadCustomersBatchFile(file), {
    onSuccess: () => {
      queryClient.invalidateQueries(["customer_batch"]);
    },
    onError: (error: ApiErrorType, variables, context) => {
      sentryLogger({
        error: error,
        data: variables,
        workflow: "customer",
        level: "error",
        functionName: "uploadBatchFile",
      });
    },
  });
};

export const useGetCustomerBatchFailuresByMutation = () => {
  return useMutation({
    mutationFn: (jobId: string) => getCustomersBatchFailures(jobId),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "customer",
        level: "error",
        functionName: "getCustomerBatchFailures",
      });
    },
  });
};

export const useGetCustomerBatchList = ({
  limit = 100,
  offset = 0,
}: {
  limit?: number;
  offset?: number;
}) => {
  return useQuery({
    queryKey: ["customer_batch", limit, offset],
    queryFn: () => getCustomersBatchList({ limit, offset }),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "customer",
        level: "error",
        functionName: "getCustomerBatchList",
      });
    },
  });
};

export const useCancelJob = () => {
  const queryClient = useQueryClient();
  return useMutation((jobId: string) => cancelCustomersBatchJob(jobId), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(["customer_batch_status", variables]);
      queryClient.invalidateQueries(["customer_batch"]);
    },
    onError: (error: ApiErrorType, variables, context) => {
      sentryLogger({
        error: error,
        data: variables,
        workflow: "customer",
        level: "error",
        functionName: "cancelJob",
      });
    },
  });
};
